import { useEffect, useState } from "react";

/**
 * Menunda update value sampai user berhenti mengetik selama `delay` ms.
 * Dipakai supaya search box tidak nembak API/filter tiap kali 1 huruf diketik.
 */
export function useDebounce<T>(value: T, delay = 400): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {

    
    const timeout = setTimeout(() => {
    
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timeout);
  }, [value, delay]);

  return debouncedValue;
}
